export default __webpack_public_path__ + "static/moodboard-52a66ac328662a3155ca1027c7ec3b8f.png";